import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import Seo from "@/components/Seo";
import EventCard from "@/components/EventCard";
import { useLang } from "@/context/LanguageContext";
import { useAuth } from "@/context/AuthContext";
import { Heart, Flame } from "lucide-react";

export default function Favorites() {
  const { t } = useLang();
  const { user, loading } = useAuth();
  const { data: favorites = [] } = useQuery({ queryKey: ["favorites"], queryFn: async () => (await api.get("/favorites")).data, enabled: !!user });

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(window.location.origin + "/favorites")}`;
  };

  if (loading) return <div className="py-24 text-center text-stone-400">{t("loading")}</div>;
  if (!user) return (
    <div className="max-w-md mx-auto px-6 py-24 text-center">
      <Flame className="w-12 h-12 text-amber-500 mx-auto mb-6" />
      <h1 className="font-serif text-2xl text-amber-100 mb-4">{t("fav_title")}</h1>
      <button data-testid="favorites-login-btn" onClick={handleLogin} className="bg-amber-600 hover:bg-amber-500 text-stone-950 font-semibold px-6 py-3 rounded-md">{t("login_google")}</button>
    </div>
  );

  return (
    <>
      <Seo title={t("fav_title")} canonicalPath="/favorites" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-12">
        <div className="flex items-center gap-3 mb-8 border-b border-amber-900/30 pb-5">
          <Heart className="w-7 h-7 text-amber-500" />
          <h1 className="font-serif text-3xl sm:text-4xl uppercase tracking-tight text-amber-100">{t("fav_title")}</h1>
        </div>
        {favorites.length === 0 ? (
          <div className="text-center py-24 text-stone-400 border border-dashed border-[#272A34] rounded-lg" data-testid="favorites-empty">{t("fav_empty")}</div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">{favorites.map((e, i) => <EventCard key={e.slug} event={e} index={i} />)}</div>
        )}
      </div>
    </>
  );
}
